import React, { Component } from "react";
import { Row, Col, Card, Button, Container, Form, Table } from "react-bootstrap";
import "./_attendanceReport.scss";
import moment from 'moment';
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { withApollo } from "react-apollo";
import MonthlyAttendanceModal from './monthlyReportModal'

class ReportTableData extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modalShow: false,
            monthData: [],
            monthNum: 0,
            employeeValue: "",


        }
    }


    openModal = (data, monthNum) => {
        this.setState({ modalShow: true, monthData: data, monthNum: monthNum })
    }

    handleEmployeeChange = (event) => {
        this.setState({
            employeeValue: event.target.value
        })
    }

    render() {

        console.log("this.props.stateData?.tableHeadMonths?", this.props.stateData)
        let headers = [
            { status: "Present/Absent/Halfday" },
            // { status: "Absent" },
            // { status: "Half day" },
            // { status: "percentage" }
        ];


        let keyword = this.state.employeeValue;

        let EmployeeData = [];

        if (keyword !== '') {
            EmployeeData = this.props.stateData.getEmployeeeAttendanceReport.length > 0 && this.props.stateData.getEmployeeeAttendanceReport.filter((item) => {
                return item.employee_name.toLowerCase().startsWith(keyword.toLowerCase());
            });
        }else{
            EmployeeData = this.props.stateData.getEmployeeeAttendanceReport
        }


        return (
            <Container className="table_data">

                <Row>
                    <Col sm={6}>
                        <input
                            className='search_bar mt-4'
                            type="search"
                            placeholder='  search by Name'
                            value={this.state.employeeValue}
                            onChange={this.handleEmployeeChange}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col sm={12}>
                        <Table className="mb-0">
                            <thead>
                                <tr>
                                    <th rowSpan="2" >Employee</th>
                                    <th rowSpan="2" >Designation</th>
                                    {
                                        this.props.stateData?.tableHeadMonths?.map((item) => {
                                            return (<th colSpan="1">{item}</th>)
                                        })
                                    }
                                </tr>
                                <tr>
                                    {
                                        this.props.stateData?.tableHeadMonths?.map((item) => {
                                            return (
                                                headers.map((item) => {
                                                    return (
                                                        (<th>{item.status}</th>)
                                                    )
                                                })
                                            )
                                        })
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    EmployeeData.length > 0 ?
                                        (
                                            EmployeeData.map((item) => {
                                                return (
                                                    <>
                                                        <tr>
                                                            <td>{item.employee_name}</td>
                                                            <td>{item.employee_type}</td>
                                                            {
                                                                item.employee_stats.map((item2) => {

                                                                    return (
                                                                        <>
                                                                            <td className="month_view" onClick={() => this.openModal(item2.monthlyReport, item2.month_num)}>

                                                                                <span className="p_box">{item2.present_days}{" "}P{"  "}</span>

                                                                                <span className="a_box">{item2.absent_days}{" "}A{"  "}</span>

                                                                                <span className="h_box">{item2.half_days}{" "}H</span></td>
                                                                        </>
                                                                    )
                                                                })
                                                            }
                                                        </tr>
                                                    </>
                                                )
                                            })
                                        )
                                        :
                                        ("")
                                }
                            </tbody>
                        </Table>
                    </Col>

                    <MonthlyAttendanceModal
                        show={this.state.modalShow}
                        onHide={() => this.setState({ modalShow: false })}
                        stateData={this.state}
                        year={this.props.stateData.year}

                    />
                </Row>
            </Container>
        )
    }
}

export default withRouter(withApollo(compose()(ReportTableData)));